var _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTriangleCircles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "triangle-circles",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "triangle-circles-left",
    cx: 24.7017,
    cy: 42.689,
    r: 14.6612,
    stroke: "#1422BD",
    strokeWidth: 2.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "triangle-circles-right",
    cx: 44.0884,
    cy: 42.689,
    r: 14.6612,
    stroke: "#1422BD",
    strokeWidth: 2.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "triangle-circles-top",
    cx: 34.0884,
    cy: 26.689,
    r: 14.6612,
    stroke: "#1422BD",
    strokeWidth: 2.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleCircles);
export default __webpack_public_path__ + "static/media/triangle-circles.62ba83c22f0b8a9b9414a818a291c96f.svg";
export { ForwardRef as ReactComponent };